import { decodeString } from "@findemdev/findem-helpers";
import { ICompanyList } from "../../../../types/common";
import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';
import { CompanyBuilder } from "../../../../../../constants/namingConventions";

dayjs.extend(relativeTime);

export const CompanyListsTableColumnKeys = [
  'companyList',
  'savedCompanies',
  'lastEdited',
  'sharedWithOrg',
  'actions',
] as const;
export type CompanyListsTableColumnKeysType = typeof CompanyListsTableColumnKeys[number];

export const CompanyListTableColumnValues: Record<CompanyListsTableColumnKeysType, {
  title: string;
}> = {
  companyList: {
    title: CompanyBuilder.allCreatedLists.table.column.listName,
  },
  savedCompanies: {
    title: 'Saved Companies',
  },
  lastEdited: {
    title: 'Last Edited',
  },
  sharedWithOrg: {
    title: 'Shared With Org',
  },
  actions: {
    title: '',
  }
}

export const getCompanyListsTableColumnValue = ({
  key,
  data,
}: {
  key: CompanyListsTableColumnKeysType,
  data: ICompanyList
}) => {
  if (key === 'companyList') {
    return decodeString(data.name);
  } else if (key === 'savedCompanies') {
    const shortlistedMetaRefs = (data.shortlist?.map((value) => value.meta_ref) ?? []).filter(val => val !== undefined);
    return shortlistedMetaRefs;
  } else if (key === 'lastEdited') {
    return dayjs(data.updated_at).fromNow();
  } else if (key === 'sharedWithOrg') {
    return null; // this doesnt exist right now check with BE
  } else if (key === 'actions') {
    return null;
  }

  throw new Error(`Unhandled column key: ${key}`);
};